import { UsageStepFormInputs } from 'features/simulation/steps/types'
import { DeliveryAddressFieldKeys, InputGroupKeys, MeterDetailsFieldKeys, SimulationFieldKeys } from 'store/customer/enums'
import { InputGroups, SimulationInputs } from 'store/customer/types'
import { getCapacityState } from 'utils/producers'
import { PopulatedLocation } from 'components/producers/new-producer-map/types'
import { COUNTER_TYPES, METER_TYPES, USAGE_GRADES } from '@boltenergy-be/shared'

/**
 * Determines the default values for the usage form based on the given inputs
 *
 * @param {InputGroups} inputs
 * @returns {UsageStepFormInputs}
 */
export const determineDefaultUsageFormValues = (inputs: InputGroups): UsageStepFormInputs => {
  const { solarKva, grade, ...usage } = inputs[InputGroupKeys.SIMULATION][SimulationFieldKeys.USAGE]

  return {
    ...usage,
    counterType: inputs[InputGroupKeys.METER_DETAILS][MeterDetailsFieldKeys.COUNTER_TYPE] || COUNTER_TYPES.digital,
    hasExclNight: inputs[InputGroupKeys.SIMULATION][SimulationFieldKeys.HAS_EXCLUSIVE_NIGHT_METER] || false,
    hasSolarPanels: inputs[InputGroupKeys.METER_DETAILS][MeterDetailsFieldKeys.HAS_SOLAR_PANELS] || false,
    meterType: inputs[InputGroupKeys.SIMULATION][SimulationFieldKeys.METER_TYPE] || METER_TYPES.single,
    needsGas: inputs[InputGroupKeys.DELIVERY_ADDRESS][DeliveryAddressFieldKeys.NEEDS_GAS] || false,
    solarKva: solarKva || undefined,
    solarPanels: inputs[InputGroupKeys.SIMULATION][SimulationFieldKeys.SOLAR_PANELS] || undefined,
    walloniaSolarPanelsSince2024: inputs[InputGroupKeys.METER_DETAILS][MeterDetailsFieldKeys.WALLONIA_SOLAR_PANELS_SINCE_2024],
    usageGrade: grade || USAGE_GRADES.low
  }
}

/**
 * Validate if the selected producer is sold out with the simulated usage.
 * @param producer The producer that will be checked for overcapacity.
 * @param simulationInputs The users inputs for the simulation.
 * @returns The current producer has exceeded it's capacity.
 */
export const isProducerOverCapacity = (producer: PopulatedLocation, simulationInputs: SimulationInputs): boolean => {
  const capacityState = getCapacityState(producer, simulationInputs, true)
  return capacityState.soldOut
}
